// extracted by mini-css-extract-plugin
export var resourceCard = "style-module--resource-card--0ec03";
export var resourceCardFilters = "style-module--resource-card--filters--120ea";
export var resourceCardMostPopular = "style-module--resource-card--most-popular--5def6";
export var resourceCardPosts = "style-module--resource-card--posts--15db0";
export var resourceCardRelated = "style-module--resource-card--related--102fb";
export var resourceCardTrending = "style-module--resource-card--trending--13f47";
export var resourceCard__badge = "style-module--resource-card__badge--34ecc";
export var resourceCard__category = "style-module--resource-card__category--47ed7";
export var resourceCard__date = "style-module--resource-card__date--15cf5";
export var resourceCard__details = "style-module--resource-card__details--2c10e";
export var resourceCard__image = "style-module--resource-card__image--819ff";
export var resourceCard__largeBadge = "style-module--resource-card__large-badge--79c19";
export var resourceCard__playIcons = "style-module--resource-card__play-icons--13761";
export var resourceCard__playIconsTitle = "style-module--resource-card__play-icons-title--c7217";
export var resourceCard__title = "style-module--resource-card__title--17164";